import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { userLoggedIn } from '@app/auth/auth.actions';

import { MembershipRenewalInterstitialService } from './membership-renewal-interstitial.service';

@Injectable()
export class MembershipRenewalInterstitialEffects {
  constructor(
    private actions$: Actions,
    private membershipRenewalInterstitialService: MembershipRenewalInterstitialService,
  ) {}

  resetInterstitialOnLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(userLoggedIn),
        tap(() => {
          // Check if URL has auth0 callbacks because that ensures we only reset on actual login
          const params = new URLSearchParams(window.location.search);
          if (params.has('code') && params.has('state')) {
            this.membershipRenewalInterstitialService.resetInterstitialStatus();
          }
        }),
      ),
    { dispatch: false },
  );
}
